import { MetadataService } from './../../../BaseFramework/core/http/metadata.service';
import { Component, OnInit, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { IntimationService } from '../../../BaseFramework/core/http/intimation.service';
import * as moment from 'moment/moment';
import { from } from 'rxjs';
import {
  InteractService,
  AppMetadataHandler,
  UserInfoService,
  ApiRequestService,
  CommonUtilty
} from 'app'
//import { default as configData } from './search-intimation.component.json';
class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: any;
  isMandatory: Boolean;
}
@Component({
  selector: 'app-intimation-bulk-upload',
  templateUrl: './intimation-bulk-upload.component.html',
  styleUrls: ['./intimation-bulk-upload.component.scss']
})
export class IntimationBulkUploadComponent implements OnInit {
  public searchResultList = []
  public CRITERIALOOKUP = [];
  public dataSet = [];
  public intimationType = null
  public bulkIntimationZeroState = {
    title: "Search Required",
    message: "Hit search to view results",
    icon: "file-search"
  }
  public bulkUploadOptions = [
    { "type": "Excel Upload" },
    { "type": "OCR Upload" }
  ]
  
  constructor(private router: Router,
    private intimationService: IntimationService,
    private metadataService: MetadataService,
    private interactService: InteractService,
    private activatedRoute: ActivatedRoute,
    public appMetadataHandler: AppMetadataHandler,
    private userInfoService: UserInfoService,
    private apiRequestService: ApiRequestService,
    private commonUtility: CommonUtilty
    ) { }

  ngOnInit() {

    this.activatedRoute.data.subscribe(data => {
      this.intimationType = data.intimationType
      this.getIntimationSearchCriteriaList();
      this.getLatestFiveTransaction(); // Will take latest five  intimations
    });
  }


  NewBulkIntimation(uploadType?) {
    this.interactService.openNewBulkIntimation(uploadType)
  }

  fetchSearchResult($event) {
    if ($event && !$event.reset) {
      if ($event && $event.results) {
        this.dataSet = $event.results;
        console.log(this.dataSet)
        if (!this.dataSet || (this.dataSet && this.dataSet.length == 0)) {
          this.bulkIntimationZeroState.title = "No Results found"
          this.bulkIntimationZeroState.message = "No records available for the selected search criteria."
        }
      }
      else {
        this.dataSet = []
      }
    }
    else this.getLatestFiveTransaction();
  }

  getIntimationSearchCriteriaList() {
    this.metadataService.fetchAPIMetaData('searchBulkIntimation')
      .subscribe(jsonResp => {
        if (jsonResp && Array.isArray(jsonResp)) {
          jsonResp.forEach(criteria => {
            let searchCriteriaDO = new SearchAPIMetaDataDO();
            searchCriteriaDO.key = criteria.attributeName;
            searchCriteriaDO.keyDescription = criteria.description;
            searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            searchCriteriaDO.lookupName = criteria.attributeLookupCd;
            searchCriteriaDO.lookup = [];
            searchCriteriaDO.enable = true;
            searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            this.CRITERIALOOKUP.push(searchCriteriaDO)
          })
        }
      })
  }
  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  openTransactionDetails(serviceTask: any, entityGuid: any) {
    let transactionDataIO: any = [];
    alert(serviceTask+" "+entityGuid);
    this.intimationService.getIntimationMetadataByGuid(entityGuid).
      subscribe(resp => {
        transactionDataIO = resp;

        this.interactService.sendIOToBulkTransaction(serviceTask, transactionDataIO)
        this.router.navigate(['/app/nbu/proposal/newBulk'], { queryParams: {}, replaceUrl: false });
      })
  }
  
  itemsPerPage: any = 5;
  currentPage: any
  searchURL = null
  getLatestFiveTransaction() {
    this.searchURL = "bulk/health/search"
    var payload = {}
    payload["size"] = this.itemsPerPage;
    payload["searchCriteriaList"] = []
    var criteriaItem = {}
    let userId = null
    userId = this.userInfoService.getUserId();
    criteriaItem = {}
    criteriaItem["paramName"] = 'criteriaUser'
    criteriaItem["paramValue"] = userId
    payload["searchCriteriaList"].push(criteriaItem)
    this.apiRequestService.post(this.searchURL, payload).subscribe(data => {
      this.dataSet = data.results;
      // this.dataSet = this.commonUtilty.deepCopy(this.healthClaimLastFiveDummyRegistrations);
    });

  }

  
  bulkStatusModal=false;
  bulkStatusData=[];
  processLoading=false;
  viewBatchStatus(metaDataGuid){
    // var URL="bulk/intMetadata/findByEntityGuid/"+metaDataGuid;  used for double data entry
    let pathVariables = [];
    pathVariables.push(metaDataGuid);
    var URL='findByEntityGuid';
    this.bulkStatusModal=true;
    this.apiRequestService.getCallWithAPIMapper(URL, null, null, pathVariables).subscribe(resp => {
      this.bulkStatusData=resp;
      this.processLoading=true;
    });
  }

  processBatch(guid,obj?) {
    let pathVariables = [];
    pathVariables.push(guid);
    var URL="findByStagingGuid";
    this.apiRequestService.getCallWithAPIMapper(URL, null, null, pathVariables).subscribe(resp => {
      let data = {"bulkList":resp, "bulkData":obj}
      this.interactService.sendIOTopProcessBulkIntimationTransaction(data)
      this.router.navigate(['/app/nbu/proposal/processBulk'], { queryParams: {}, replaceUrl: false });
    });
  }

  getLocalDateString(rawDate){
    
    let dateString
    let tempDate = this.commonUtility.deepCopy(rawDate)
    tempDate = this.commonUtility.serverDOtoUIDODate(tempDate);
    if (tempDate != null) {
      dateString = moment(tempDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = '-'
    }
    return dateString
  }
}


